import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isBetween from "dayjs/plugin/isBetween";
import { BACKEND_DATE_FORMAT, siteDayjs } from "./siteTimezone.js";
dayjs.extend(customParseFormat);
dayjs.extend(isBetween);

export function getNext7Days(siteTimezone) {
  return Array.from({ length: 7 }, (_, i) => {
    const date = siteDayjs(null, siteTimezone).add(i, "day");
    return date.format(BACKEND_DATE_FORMAT);
  });
}

export function filterNext7Days(rows, siteTimezone) {
  const today = siteDayjs(null, siteTimezone).startOf("day");
  const end = today.add(6, "day");

  const todayFormatted = today.format(BACKEND_DATE_FORMAT);
  const endFormatted = end.format(BACKEND_DATE_FORMAT);

  return rows.filter((row) =>
    siteDayjs(row.harvestDay, siteTimezone).isBetween(todayFormatted, endFormatted, null, "[]"),
  );
}

export function getWeekMode(siteTimezone) {
  const dow = siteDayjs(null, siteTimezone).day(); // 0=Sun, 1=Mon, 2=Tue, 3=Wed, 4=Thu, 5=Fri, 6=Sat
  // return dow >= 3 && dow <= 6 ? "split" : "simple";
  return "split"
}

// Helper: Get the Monday of the week containing this date (Monday = day 0)
function getMonday(date) {
  const day = date.day(); // 0=Sun, 1=Mon, 2=Tue, 3=Wed, 4=Thu, 5=Fri, 6=Sat
  const offset = day === 0 ? -6 : 1 - day; // Calculate offset to Monday
  return date.add(offset, 'day');
}

export function getCurrentWeekDays(siteTimezone) {
  // Returns Monday through Sunday of current calendar week
  const today = siteDayjs(null, siteTimezone);
  const monday = getMonday(today);
  return Array.from({ length: 7 }, (_, i) =>
    monday.add(i, 'day').format(BACKEND_DATE_FORMAT),
  );
}

export function getNextWeekDays(siteTimezone) {
  // Returns Monday through Sunday of next calendar week
  const today = siteDayjs(null, siteTimezone);
  const monday = getMonday(today);
  const nextMonday = monday.add(7, 'day');
  return Array.from({ length: 7 }, (_, i) =>
    nextMonday.add(i, 'day').format(BACKEND_DATE_FORMAT),
  );
}

export function getAllDisplayedDays(siteTimezone) {
  // Returns all days that should be shown in the UI based on week mode
  const weekMode = getWeekMode(siteTimezone);
  if (weekMode === "simple") {
    return getNext7Days(siteTimezone);
  } else {
    // Split mode: current week + next week (both ranges combined)
    const current = getCurrentWeekDays(siteTimezone);
    const next = getNextWeekDays(siteTimezone);
    return [...current, ...next];
  }
}

// Number of days the optimiser forecasts, counting today as day 1.
export const FORECAST_WINDOW_DAYS = 12;

export function getForecastWindow(siteTimezone) {
  // Returns the forecast window (today through today + FORECAST_WINDOW_DAYS - 1)
  const today = siteDayjs(null, siteTimezone);
  return Array.from({ length: FORECAST_WINDOW_DAYS }, (_, i) =>
    today.add(i, "day").format(BACKEND_DATE_FORMAT),
  );
}

export function compareYield(recommendedYield, newYield) {
  console.log("newYield", newYield);
  if (
    !recommendedYield ||
    !newYield ||
    recommendedYield == null ||
    newYield == null ||
    isNaN(recommendedYield) ||
    isNaN(newYield)
  ) {
    return "";
  }

  if (recommendedYield === 0) {
    return "";
  }

  const diff = newYield - recommendedYield;

  if (diff === 0) {
    return ``; //recommended yield
  }

  const percentage = Math.abs((diff / recommendedYield) * 100).toFixed(2);

  const direction = diff > 0 ? "higher" : "lower";

  return `${percentage}% ${direction} yield than recommended`;
}

export function demoDateFix(plan) {
  return plan.map((item) => {
    const subtractMonth = (dateStr) => {
      if (!dateStr) return dateStr;
      return dayjs(dateStr).subtract(1, "month").format("YYYY-MM-DD");
    };
    return {
      ...item,
      harvest_pass_day_1_date: subtractMonth(item.harvest_pass_day_1_date),
      harvest_pass_day_2_date: subtractMonth(item.harvest_pass_day_2_date),
    };
  });
}

export const convertToTon = (kg) => Math.floor(kg / 1000);

export const convertToBin = (kg, kgPerBin) => {
  if (!kgPerBin || kgPerBin <= 0) return null;
  return Math.floor(kg / kgPerBin);
};
